<template>
  <div class="search-filter mb-3">
    <b-input-group>
      <b-form-input
        v-model="query"
        :placeholder="$t('PQTOffersView.searchProducts')"
        class="search-input"
        @input="onQueryChange"
      />
      <b-input-group-append>
        <b-button
          variant="outline-secondary"
          @click="clearSearch"
        >
          <i class="fa fa-times" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: "SearchFilter",
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      query: this.value
    };
  },
  watch: {
    value(newVal) {
      this.query = newVal;
    }
  },
  methods: {
    onQueryChange() {
      this.$emit('input', this.query);
    },
    clearSearch() {
      this.query = '';
      this.$emit('input', '');
    }
  }
};
</script>

<style scoped>
.search-filter {
  max-width: 400px;
}

.search-input {
  border-radius: 4px;
  border: 1px solid #CED4DA;
}
</style>